
import PassaggioDocumentale from './PassaggioDocumentale'
import FormPassaggioDocumentale from './FormPassaggioDocumentale'
import './Hailbox.css'

const Hailbox =  ({data}) =>{
    // View PassaggioDocumentale
    return (
        <div className='main-container-hailbox'>
            <div className='section-hailbox'>
                <h3>File Passaggio Documentale</h3>
                <PassaggioDocumentale />
            </div>
            <div className='section-hailbox'>
                <h3>Form Passaggio Documentale</h3>
                <FormPassaggioDocumentale />
            </div>
        </div>
    )
} 


export default Hailbox
